export const festivalSyllabus = [
    {
      exam: 'CBSE',
      data: [
          {
            grade: '6',
            subjects: [
              {
                subName: 'Maths',
                imageUrl: '/assets/img/festival/math.png',
                className: 'mat-box',
                syllabus: [
                  {
                    topic: 'Algebra',
                    subtopic: [],
                  },
                  {
                    topic: 'Basic Geometrical Ideas',
                    subtopic: [],
                  },
                  {
                    topic: 'Data Handling',
                    subtopic: [],
                  },
                  {
                    topic: 'Decimals',
                    subtopic: [],
                  },
                  {
                    topic: 'Fractions',
                    subtopic: [],
                  },
                  {
                    topic: 'Integers',
                    subtopic: [],
                  },
                  {
                    topic: 'Knowing our Numbers',
                    subtopic: [],
                  },
                  {
                    topic: 'Mensuration',
                    subtopic: [],
                  },
                  {
                    topic: 'Playing with Numbers',
                    subtopic: [],
                  },
                  {
                    topic: 'Practical Geometry',
                    subtopic: [],
                  },
                  {
                    topic: 'Ratio and Proportion',
                    subtopic: [],
                  },
                  {
                    topic: 'Symmetry',
                    subtopic: [],
                  },
                  {
                    topic: 'Understanding Elementary Shapes',
                    subtopic: [],
                  },
                  {
                    topic: 'Whole Numbers',
                    subtopic: [],
                  },
                ],
              },
        
              {
                subName: 'Science',
                imageUrl: '/assets/img/festival/science.png',
                className: 'sci-box',
                syllabus: [
                  {
                    topic: 'Air Around Us',
                    subtopic: [],
                  },
                  {
                    topic: 'Changes Around Us',
                    subtopic: [],
                  },
                  {
                    topic: 'Fibre To Fabric',
                    subtopic: [],
                  },
                  {
                    topic: 'Separation Of Substances',
                    subtopic: [],
                  },
                  {
                    topic: 'Sorting Materials Into Groups',
                    subtopic: [],
                  },
                  {
                    topic: 'Electricity and Circuits',
                    subtopic: [],
                  },
                  {
                    topic: 'Fun with Magnets',
                    subtopic: [],
                  },
                  {
                    topic: 'Light, Shadows and Reflections',
                    subtopic: [],
                  },
                  {
                    topic: 'Motion and Measurement of Distances',
                    subtopic: [],
                  },
                  {
                    topic: 'Body Movements',
                    subtopic: [],
                  },
                  {
                    topic: 'Components Of Food',
                    subtopic: [],
                  },
                  {
                    topic: 'Food: Where Does It Come From?',
                    subtopic: [],
                  },
                  {
                    topic: 'Garbage In, Garbage Out',
                    subtopic: [],
                  },
                  {
                    topic: 'Getting To Know Plants',
                    subtopic: [],
                  },
                  {
                    topic: 'The Living Organisms - Characteristics & Habitats',
                    subtopic: [],
                  },
                  {
                    topic: 'Water',
                    subtopic: [],
                  },
                ],
              },
            ],
            faqs: [
              {
                question: 'How old are students when they usually make it to Grade 6?',
                answer:
                  'Students are usually aged between 11-12 years when they attend Grade 6.',
              },
              {
                question: 'What are the compulsory subjects to study in Grade 6?',
                answer:
                  'There are six compulsory subjects: Science, Mathematics, Social Science, English, Hindi, Third Language (Urdu, Sanskrit etc.).',
              },
              {
                question: 'Can I score well using the school textbooks in Grade 6?',
                answer:
                  "It is good for students to refer to reference books along with NCERT to get more concept clarity.",
              },
              {
                question: 'Should all questions of NCERT book be solved/practiced?',
                answer:
                  'Yes! All questions from NCERT should be solved and practiced before the exam. You can also refer to other reference books.',
              },
              {
                question:
                  'Is there a need to study any other language beside English and Hindi in Grade 6?',
                answer:
                  'Yes, you must choose a third language. Most of the school offers Sanskrit and Urdu as the third language but you can get to study different languages, such as German, and Spanish, based on the languages provided by your school.',
              },
              {
                question: 'How many hours a day should I study regularly in Grade 6?',
                answer:
                  'If you follow the routine of studying at least one or two hours every day and not leave the preparation to just two to three months before the exam you can great a good score in grade 6. But, remember to take notes to help you during revision.',
              },
              {
                question:
                  'When should we start solving test papers and modal papers for Grade 6 exams?',
                answer:
                  'You can start solving tests as soon as concepts are taught and some practice is done. Modal papers that cover multiple chapters can be taken up after respective chapters are completed, especially in few weeks before the exam. We suggest you do not leave tests till the last moment. Learn from NCERT/reference books, practice from question banks and test your knowledge using tests in a routine manner.',
              },
              {
                question: 'Can I score good marks by studying myself?',
                answer:
                  'Self-study is important but getting good marks by just self-study differs from student to student. If you find some subjects or concepts difficult to understand, then taking help is advisable. Infinity Learn provides study material and live classes for students and helps them score good marks',
              },
              {
                question:
                  'Is it advisable to use a calculator while solving Mathematics questions? ',
                answer:
                  "It is not advisable to solve questions using a calculator as it decreases your mental ability to solve questions. Most competitive exams do not allow the use of calculators.",
              },
              {
                question:
                  'Which subscription plans are available for Grade 6 on Infinity Learn?',
                answer:
                  'Infinity Learn provides study material and live classes for students and helps them score good marks. There are various packages offering multiple features for students depending on their needs. Please contact us for free counselling session.',
              },
            ],
            packages: [
              {
                packageName: '',
                features: [],
              },
            ],
          },
          {
            grade: '7',
            subjects: [
              {
                subName: 'Maths',
                imageUrl: '/assets/img/festival/math.png',
                className: 'mat-box',
                syllabus: [
                  {
                    topic: 'Algebraic Expressions ',
                    subtopic: [],
                  },
                  {
                    topic: 'Comparing Quantities',
                    subtopic: [],
                  },
                  {
                    topic: 'Congruence of Triangles',
                    subtopic: [],
                  },
                  {
                    topic: 'Data Handling',
                    subtopic: [],
                  },
                  {
                    topic: 'Exponents and Powers',
                    subtopic: [],
                  },
                  {
                    topic: 'Fractions and Decimals ',
                    subtopic: [],
                  },
                  {
                    topic: 'Integers',
                    subtopic: [],
                  },
                  {
                    topic: ' Lines and Angles',
                    subtopic: [],
                  },
                  {
                    topic: 'Perimeter and Area',
                    subtopic: [],
                  },
                  {
                    topic: 'Practical Geometry',
                    subtopic: [],
                  },
                  {
                    topic: 'Rational Numbers',
                    subtopic: [],
                  },
                  {
                    topic: 'Simple Equations',
                    subtopic: [],
                  },
                  {
                    topic: 'Symmetry',
                    subtopic: [],
                  },
                  {
                    topic: 'The Triangle and Its Properties ',
                    subtopic: [],
                  },
                  {
                    topic: 'Visualising  Solid Shapes',
                    subtopic: [],
                  },
                ],
              },
        
              {
                subName: 'Science',
                imageUrl: '/assets/img/festival/science.png',
                className: 'sci-box',
                syllabus: [
                  {
                    topic: 'Acids, Bases And Salts',
                    subtopic: [],
                  },
                  {
                    topic: 'Fibre To Fabric',
                    subtopic: [],
                  },
                  {
                    topic: 'Physical And Chemical Changes',
                    subtopic: [],
                  },
                  {
                    topic: 'Soil',
                    subtopic: [],
                  },
                  {
                    topic: 'Electric Current and Its Effects',
                    subtopic: [],
                  },
                  {
                    topic: 'Heat',
                    subtopic: [],
                  },
                  {
                    topic: 'Light',
                    subtopic: [],
                  },
                  {
                    topic: 'Motion and Time',
                    subtopic: [],
                  },
                  {
                    topic: 'Winds, Storm and Cyclones ',
                    subtopic: [],
                  },
                  {
                    topic: 'Forests: Our Life Line',
                    subtopic: [],
                  },
                  {
                    topic: 'Nutrition In Animals',
                    subtopic: [],
                  },
                  {
                    topic: 'Nutrition In Plants',
                    subtopic: [],
                  },
                  {
                    topic: 'Reproduction In Plants',
                    subtopic: [],
                  },
                  {
                    topic: 'Respiration In Organisms',
                    subtopic: [],
                  },
                  {
                    topic: 'Transportation In Animals And Plants',
                    subtopic: [],
                  },
                  {
                    topic: 'Waste Water Story',
                    subtopic: [],
                  },
                  {
                    topic: 'Water: A Precious Resource',
                    subtopic: [],
                  },
                  {
                    topic: 'Weather, Climate & Adaptations Of Animals To Climate',
                    subtopic: [],
                  },
                ],
              },
            ],
            faqs: [
              {
                question: 'How old are students when they usually make it to Grade 7?',
                answer:
                  'Students are usually aged between 12-13 years when they attend Grade 7.',
              },
              {
                question: 'What are the compulsory subjects to study in Grade 7?',
                answer:
                  'There are six compulsory subjects: Science, Mathematics, Social Science, English, Hindi, Third Language (Urdu, Sanskrit etc.).',
              },
              {
                question: 'Can I score well using the school textbooks in Grade 7?',
                answer:
                  "It is good for students to refer to reference books along with NCERT to get more concept clarity. ",
              },
              {
                question: 'Should all questions of NCERT book be solved/practiced? ',
                answer:
                  'Yes! All questions from NCERT should be solved and practiced before the exam. You can also refer to other reference books.',
              },
              {
                question:
                  'Is there a need to study any other language beside English and Hindi in Grade 7?',
                answer:
                  'Yes, you must choose a third language. Most of the school offers Sanskrit and Urdu as the third language but you can get to study different languages, such as German, and Spanish, based on the languages provided by your school.',
              },
              {
                question: 'How many hours a day should I study regularly in Grade 7?',
                answer:
                  'If you follow the routine of studying at least one or two hours every day and not leave the preparation to just two to three months before the exam you can great a good score in grade 7. But, remember to take notes to help you during revision.',
              },
              {
                question:
                  'When should we start solving test papers and modal papers for Grade 7 exams?',
                answer:
                  'You can start solving tests as soon as concepts are taught and some practice is done. Modal papers that cover multiple chapters can be taken up after respective chapters are completed, especially in few weeks before the exam. We suggest you do not leave tests till the last moment. Learn from NCERT/reference books, practice from question banks and test your knowledge using tests in a routine manner.',
              },
              {
                question: 'Can I score good marks by studying myself?',
                answer:
                  'Self-study is important but getting good marks by just self-study differs from student to student. If you find some subjects or concepts difficult to understand, then taking help is advisable. Infinity Learn provides study material and live classes for students and helps them score good marks',
              },
              {
                question:
                  'Is it advisable to use a calculator while solving Mathematics questions?',
                answer:
                  "It is not advisable to solve questions using a calculator as it decreases your mental ability to solve questions. Most competitive exams do not allow the use of calculators.",
              },
              {
                question:
                  'Which subscription plans are available for Grade 7 on Infinity Learn?',
                answer:
                  'Infinity Learn provides study material and live classes for students and helps them score good marks. There are various packages offering multiple features for students depending on their needs. Please contact us for a free counselling session.',
              },
            ],
            packages: [
              {
                packageName: '',
                features: [],
              },
            ],
          },
          {
            grade: '8',
            subjects: [
              {
                subName: 'Maths',
                imageUrl: '/assets/img/festival/math.png',
                className: 'mat-box',
                syllabus: [
                  {
                    topic: 'Rational numbers',
                    subtopic: [],
                  },
                  {
                    topic: 'Linear equations with one variable',
                    subtopic: [],
                  },
                  {
                    topic: 'Comparing quantities',
                    subtopic: [],
                  },
                  {
                    topic: 'Important Mensuration topics',
                    subtopic: [],
                  },
                  {
                    topic: 'Identities and important algebraic equations',
                    subtopic: [],
                  },
                  {
                    topic: 'Practical usage of geometry',
                    subtopic: [],
                  },
                  {
                    topic: 'Introductory concepts of graphs',
                    subtopic: [],
                  },
                  {
                    topic: 'Solid shapes and their visualisation',
                    subtopic: [],
                  },
                  {
                    topic: 'Powers and Exponents',
                    subtopic: [],
                  },
                  {
                    topic: 'Understanding and introduction of Quadrilaterals',
                    subtopic: [],
                  },
                  {
                    topic: 'Cubes and Cube roots',
                    subtopic: [],
                  },
                  {
                    topic: 'Introductory concepts of graphs',
                    subtopic: [],
                  },
                  {
                    topic: 'Number problems',
                    subtopic: [],
                  },
                  {
                    topic: 'Understanding Direct and Inverse proportions',
                    subtopic: [],
                  },
                  {
                    topic: 'Square roots and squares',
                    subtopic: [],
                  },
                  {
                    topic: 'Data handling',
                    subtopic: [],
                  },
                ],
              },
        
              {
                subName: 'Science',
                imageUrl: '/assets/img/festival/science.png',
                className: 'sci-box',
                syllabus: [
                  {
                    topic: 'Crop Production and Management',
                    subtopic: [],
                  },
                  {
                    topic: 'Microorganisms: Friend and Foe',
                    subtopic: [],
                  },
                  {
                    topic: 'Synthetic Fibers and Plastics',
                    subtopic: [],
                  },
                  {
                    topic: 'Metals and Non-Metals',
                    subtopic: [],
                  },
                  {
                    topic: 'Coal and Petroleum',
                    subtopic: [],
                  },
                  {
                    topic: 'Combustion and Flame',
                    subtopic: [],
                  },
                  {
                    topic: 'Conservation of Plants and Animals',
                    subtopic: [],
                  },
                  {
                    topic: 'Cell Structure and Function',
                    subtopic: [],
                  },
                  {
                    topic: 'Reproduction in Animals',
                    subtopic: [],
                  },
                ],
              },
            ],
          },
          {
            grade: '9',
            subjects: [
              {
                subName: 'Maths',
                imageUrl: '/assets/img/festival/math.png',
                className: 'mat-box',
                syllabus: [
                  {
                    topic: 'Polynomials',
                    subtopic: [],
                  },
                  {
                    topic: 'Co-ordinate System',
                    subtopic: [],
                  },
                  {
                    topic: 'Linear Equations in Two Variables',
                    subtopic: [],
                  },
                  {
                    topic: 'Introduction to Euclid`s Geometry',
                    subtopic: [],
                  },
                  {
                    topic: 'Lines Angles',
                    subtopic: [],
                  },
                  {
                    topic: 'Triangles',
                    subtopic: [],
                  },
                  {
                    topic: 'Quadrilaterals',
                    subtopic: [],
                  },
                  {
                    topic: 'Areas of Parallelograms & Triangles',
                    subtopic: [],
                  },
                  {
                    topic: 'Circles',
                    subtopic: [],
                  },
                  {
                    topic: 'Constructions',
                    subtopic: [],
                  },
                  {
                    topic: 'Heron`s Formula',
                    subtopic: [],
                  },
                  {
                    topic: 'Surface Area and Volume',
                    subtopic: [],
                  },
                  {
                    topic: 'Statistics',
                    subtopic: [],
                  },
                  {
                    topic: 'Probalility',
                    subtopic: [],
                  },
                ],
              },
              {
                subName: 'Science',
                imageUrl: '/assets/img/festival/science.png',
                className: 'sci-box',
                syllabus: [
                  {
                    topic: 'Force and laws of motion',
                    subtopic: [],
                  },
                  {
                    topic: 'Gravitation',
                    subtopic: [],
                  },
                  {
                    topic: 'Work and energy',
                    subtopic: [],
                  },
                  {
                    topic: 'Sound',
                    subtopic: [],
                  },
                  {
                    topic: 'Matter in our surroundings',
                    subtopic: [],
                  },
                  {
                    topic: 'Is matter around us pure',
                    subtopic: [],
                  },
                  {
                    topic: 'Atoms and Molecules',
                    subtopic: [],
                  },
                  {
                    topic: 'Structure of Atom',
                    subtopic: [],
                  },
                  {
                    topic: 'The fundamental unit of life',
                    subtopic: [],
                  },
                  {
                    topic: 'Tissues',
                    subtopic: [],
                  },
                  {
                    topic: 'Diversity in living organisms',
                    subtopic: [],
                  },
                  {
                    topic: 'Why do we fall ill?',
                    subtopic: [],
                  },
                  {
                    topic: 'Natural resources',
                    subtopic: [],
                  },
                  {
                    topic: 'Improvement in food resources',
                    subtopic: [],
                  },
                ],
              },
            ],
          },
          {
            grade: '10',
            subjects: [
              {
                subName: 'Maths',
                imageUrl: '/assets/img/festival/math.png',
                className: 'mat-box',
                syllabus: [
                  {
                    topic: 'Numbers',
                    subtopic: [],
                  },
                  {
                    topic: 'Polynomials',
                    subtopic: [],
                  },
                  {
                    topic: 'Pair of Linear Equations in Two Variables',
                    subtopic: [],
                  },
                  {
                    topic: 'Quadratic Equation',
                    subtopic: [],
                  },
                  {
                    topic: 'Arithmetic Progressions',
                    subtopic: [],
                  },
                  {
                    topic: 'Co-Ordinate Geometry',
                    subtopic: [],
                  },
                  {
                    topic: 'Triangles',
                    subtopic: [],
                  },
                  {
                    topic: 'Introduction to Trigonometry',
                    subtopic: [],
                  },
                  {
                    topic: 'Some Applications of Trigonometry',
                    subtopic: [],
                  },
                  {
                    topic: 'Circles',
                    subtopic: [],
                  },
                  {
                    topic: 'Constructions',
                    subtopic: [],
                  },
                  {
                    topic: 'Areas Related to Circles',
                    subtopic: [],
                  },
                  {
                    topic: 'Surface Areas and Volumes',
                    subtopic: [],
                  },
                  {
                    topic: 'Statistics',
                    subtopic: [],
                  },
                  {
                    topic: 'Probability',
                    subtopic: [],
                  },
                ],
              },
              {
                subName: 'Science',
                imageUrl: '/assets/img/festival/science.png',
                className: 'sci-box',
                syllabus: [
                  {
                    topic: 'Light – reflection and refraction',
                    subtopic: [],
                  },
                  {
                    topic: 'The human eye and the colourful world',
                    subtopic: [],
                  },
                  {
                    topic: 'Electricity',
                    subtopic: [],
                  },
                  {
                    topic: 'Magnetic effects of electric current',
                    subtopic: [],
                  },
                  {
                    topic: 'Sources of energy',
                    subtopic: [],
                  },
                  {
                    topic: 'Life Processes',
                    subtopic: [],
                  },
                  {
                    topic: 'Control and coordination',
                    subtopic: [],
                  },
                  {
                    topic: 'How do organisms reproduce ?',
                    subtopic: [],
                  },
                  {
                    topic: 'Heredity and evolution',
                    subtopic: [],
                  },
                  {
                    topic: 'Our environment',
                    subtopic: [],
                  },
                  {
                    topic: 'Sustainable management of natural resources',
                    subtopic: [],
                  },
                  {
                    topic: 'Chemical reactions and equations',
                    subtopic: [],
                  },
                  {
                    topic: 'Acids bases and salts',
                    subtopic: [],
                  },
                  {
                    topic: 'Metals and non metals',
                    subtopic: [],
                  },
                  {
                    topic: 'Carbon and its compounds',
                    subtopic: [],
                  },
                  {
                    topic: 'Periodic classification of elements',
                    subtopic: [],
                  },
                ],
              },
            ],
          },          
          {
            grade: '11',
            subjects: [
              {
                subName: 'Maths',
                imageUrl: '/assets/img/festival/math.png',
                className: 'mat-box',
                syllabus: [
                  {
                    topic: 'Sets and functions',
                    subtopic: [],
                  },
                  {
                    topic: 'Algebra',
                    subtopic: [],
                  },
                  {
                    topic: 'Coordinate Geometry',
                    subtopic: [],
                  },
                  {
                    topic: 'Calculus',
                    subtopic: [],
                  },
                  {
                    topic: 'Statistics and probability',
                    subtopic: [],
                  },
                  {
                    topic: 'Trigonometric Functions',
                    subtopic: [],
                  },
                  {
                    topic: 'Linear Inequalities',
                    subtopic: [],
                  },
                  {
                    topic: 'Permutations and Combinations',
                    subtopic: [],
                  },
                  {
                    topic: 'Conic Sections',
                    subtopic: [],
                  },
                  {
                    topic: 'Introduction to Three-dimensional Geometry',
                    subtopic: [],
                  },
                  {
                    topic: 'Derivatives',
                    subtopic: [],
                  },
                  {
                    topic: 'Probability',
                    subtopic: [],
                  },
                ],
              },
              {
                subName: 'Physics',
                imageUrl: '/assets/img/festival/physics.png',
                className: 'phy-box',
                syllabus: [
                  {
                    topic: 'Physical World',
                    subtopic: [],
                  },
                  {
                    topic: 'Units of measurement',
                    subtopic: [],
                  },
                  {
                    topic: 'Motions in straight line',
                    subtopic: [],
                  },
                  {
                    topic: 'Motion in a plane',
                    subtopic: [],
                  },
                  {
                    topic: 'Laws of motion',
                    subtopic: [],
                  },
                  {
                    topic: 'Work, Energy, power',
                    subtopic: [],
                  },
                  {
                    topic: 'System of particles and rotational motion',
                    subtopic: [],
                  },
                  {
                    topic: 'Gravitation ',
                    subtopic: [],
                  },
                  {
                    topic: 'Mechanical Properties of Solids ',
                    subtopic: [],
                  },
                  {
                    topic: 'Mechanical Properties of Fluids',
                    subtopic: [],
                  },
                  {
                    topic: 'Thermal Properties of Matter',
                    subtopic: [],
                  },
                  {
                    topic: 'Thermodynamics',
                    subtopic: [],
                  },
                  {
                    topic: 'Kinetic Theory',
                    subtopic: [],
                  },
                  {
                    topic: 'Oscillations',
                    subtopic: [],
                  },
                  {
                    topic: 'Waves',
                    subtopic: [],
                  },
                ],
              },
              {
                subName: 'Chemistry',
                imageUrl: '/assets/img/festival/chemistry.png',
                className: 'che-box',
                syllabus: [
                  {
                    topic: 'Some basic concepts of chemistry',
                    subtopic: [],
                  },
                  {
                    topic: 'Structure of Atom ',
                    subtopic: [],
                  },
                  {
                    topic: 'Classification of elements and periodicity in properties',
                    subtopic: [],
                  },
                  {
                    topic: 'Chemical bonding and molecular structure ',
                    subtopic: [],
                  },
                  {
                    topic: 'Redox reactions ',
                    subtopic: [],
                  },
                  {
                    topic: 'Hydrogen ',
                    subtopic: [],
                  },
                  {
                    topic: 'Organic chemistry: Some basic principles and techniques. ',
                    subtopic: [],
                  },
                  {
                    topic: 'States of Matter: Gases and Liquids',
                    subtopic: [],
                  },
                  {
                    topic: 'Chemical Thermodynamics',
                    subtopic: [],
                  },
                  {
                    topic: 'Equilibrium',
                    subtopic: [],
                  },
                  {
                    topic: 's -Block Elements',
                    subtopic: [],
                  },
                  {
                    topic: 'Some p -Block Elements',
                    subtopic: [],
                  },
                  {
                    topic: 'Hydrocarbons',
                    subtopic: [],
                  },
                ],
              },
              {
                subName: 'Biology',
                imageUrl: '/assets/img/festival/biology.png',
                className: 'bio-box',
                syllabus: [
                  {
                    topic: 'Cell Cycle and Cell Division',
                    subtopic: [],
                  },
                  {
                    topic: 'Photosynthesis in Higher Plants',
                    subtopic: [],
                  },
                  {
                    topic: 'Respiration in Plants',
                    subtopic: [],
                  },
                  {
                    topic: 'Plant - Growth and Development',
                    subtopic: [],
                  },
                  //Zoology
                  {
                    topic: 'Breathing and Exchange of Gases',
                    subtopic: [],
                  },
                  {
                    topic: 'Body Fluids and Circulation',
                    subtopic: [],
                  },
                  {
                    topic: 'Excretory Products and their Elimination',
                    subtopic: [],
                  },
                  {
                    topic: 'Locomotion and Movement',
                    subtopic: [],
                  },
                  {
                    topic: 'Neural Control and Coordination',
                    subtopic: [],
                  },
                  {
                    topic: 'Chemical Coordination and Integration',
                    subtopic: [],
                  },
                ],
              },
            ],
          },
          {
            grade: '12',
            subjects: [
              {
                subName: 'Maths',
                imageUrl: '/assets/img/festival/math.png',
                className: 'mat-box',
                syllabus: [
                  {
                    topic: 'Relations and Functions',
                    subtopic: [],
                  },
                  {
                    topic: 'Inverse Trigonometric Functions',
                    subtopic: [],
                  },
                  {
                    topic: 'Matrices',
                    subtopic: [],
                  },
                  {
                    topic: 'Determinants',
                    subtopic: [],
                  },
                  {
                    topic: 'Continuity and Differentiability',
                    subtopic: [],
                  },
                  {
                    topic: 'Application of Derivatives',
                    subtopic: [],
                  },
                  {
                    topic: 'Integrals',
                    subtopic: [],
                  },
                  {
                    topic: 'Application of Integrals',
                    subtopic: [],
                  },
                  {
                    topic: 'Differential Equations',
                    subtopic: [],
                  },
                  {
                    topic: 'Vector Algebra',
                    subtopic: [],
                  },
                  {
                    topic: 'Three Dimensional Geometry',
                    subtopic: [],
                  },
                  {
                    topic: 'Linear Programming',
                    subtopic: [],
                  },
                  {
                    topic: 'Probability',
                    subtopic: [],
                  },
                ],
              },
              {
                subName: 'Physics',
                imageUrl: '/assets/img/festival/physics.png',
                className: 'phy-box',
                syllabus: [
                  {
                    topic: 'Electric Charges & Fields',
                    subtopic: [],
                  },
                  {
                    topic: 'Electrostatic Potential & Capacitance',
                    subtopic: [],
                  },
                  {
                    topic: 'Current Electricity',
                    subtopic: [],
                  },
                  {
                    topic: 'Moving Charges and Magnetism',
                    subtopic: [],
                  },
                  {
                    topic: 'Magnetism and Matter',
                    subtopic: [],
                  },
                  {
                    topic: 'Electromagnetic Induction',
                    subtopic: [],
                  },
                  {
                    topic: 'Alternating Current',
                    subtopic: [],
                  },
                  {
                    topic: 'Electromagnetic Waves',
                    subtopic: [],
                  },
                  {
                    topic: 'Ray Optics and Optical Instruments',
                    subtopic: [],
                  },
                  {
                    topic: 'Wave Optics',
                    subtopic: [],
                  },
                  {
                    topic: 'Dual Nature of Radiation and Matter',
                    subtopic: [],
                  },
                  {
                    topic: 'Atoms',
                    subtopic: [],
                  },
                  {
                    topic: 'Nuclei',
                    subtopic: [],
                  },
                  {
                    topic: 'Semiconductor Electronics: Materials, Devices, and Simple Circuits',
                    subtopic: [],
                  },
                  {
                    topic: 'Communication Systems',
                    subtopic: [],
                  },
                ],
              },
              {
                subName: 'Chemistry',
                imageUrl: '/assets/img/festival/chemistry.png',
                className: 'che-box',
                syllabus: [
                  {
                    topic: 'The Solid State',
                    subtopic: [],
                  },
                  {
                    topic: 'Solutions',
                    subtopic: [],
                  },
                  {
                    topic: 'Electrochemistry',
                    subtopic: [],
                  },
                  {
                    topic: 'Chemical Kinetics',
                    subtopic: [],
                  },
                  {
                    topic: 'Surface Chemistry',
                    subtopic: [],
                  },
                  {
                    topic: 'General Principles and Processes of Isolation of Elements',
                    subtopic: [],
                  },
                  {
                    topic: 'The p-Block Elements',
                    subtopic: [],
                  },
                  {
                    topic: 'The d-and f-Block Elements',
                    subtopic: [],
                  },
                  {
                    topic: 'Coordination Compounds',
                    subtopic: [],
                  },
                  {
                    topic: 'Haloalkanes and Haloarenes',
                    subtopic: [],
                  },
                  {
                    topic: 'Alcohols, Phenols and Ethers',
                    subtopic: [],
                  },
                  {
                    topic: 'Aldehydes, Ketones and Carboxylic Acids',
                    subtopic: [],
                  },
                  {
                    topic: 'Amines',
                    subtopic: [],
                  },
                  {
                    topic: 'Biomolecules',
                    subtopic: [],
                  },
                  {
                    topic: 'Polymers',
                    subtopic: [],
                  },
                  {
                    topic: 'Chemistry in Everyday Life',
                    subtopic: [],
                  },
                ],
              },
              {
                subName: 'Biology',
                imageUrl: '/assets/img/festival/biology.png',
                className: 'bio-box',
                syllabus: [
                  {
                    topic: 'Reproduction in Organisms',
                    subtopic: [],
                  },
                  {
                    topic: 'Sexual Reproduction in Flowering Plants',
                    subtopic: [],
                  },
                  {
                    topic: 'Strategies for Enhancement in Food Production',
                    subtopic: [],
                  },
                  {
                    topic: 'Biotechnology: Principles and Processes',
                    subtopic: [],
                  },
                  {
                    topic: 'Biotechnology and its Applications',
                    subtopic: [],
                  },
                  {
                    topic: 'Organisms and Populations',
                    subtopic: [],
                  },
                  {
                    topic: 'Ecosystem',
                    subtopic: [],
                  },
                  {
                    topic: 'Environmental Issues',
                    subtopic: [],
                  },
                  //Zoology
                  {
                    topic: 'Human Reproduction',
                    subtopic: [],
                  },
                  {
                    topic: 'Reproductive Health',
                    subtopic: [],
                  },
                  {
                    topic: 'Principles of Inheritance',
                    subtopic: [],
                  },
                  {
                    topic: 'Evolution',
                    subtopic: [],
                  },
                  {
                    topic: 'Human Health and Diseases',
                    subtopic: [],
                  },
                  {
                    topic: 'Microbes in Human Welfare',
                    subtopic: [],
                  },
                ],
              },
            ],
          },
        ]
    },
    {
        exam: 'JEE',
        data : [
              {
                grade: '11',
                subjects: [
                  {
                    subName: 'Maths',
                    imageUrl: '/assets/img/festival/math.png',
                    className: 'mat-box',
                    syllabus: [
                      {
                        topic: 'Sets and functions',
                        subtopic: [],
                      },
                      {
                        topic: 'Algebra',
                        subtopic: [],
                      },
                      {
                        topic: 'Coordinate Geometry',
                        subtopic: [],
                      },
                      {
                        topic: 'Calculus',
                        subtopic: [],
                      },
                      {
                        topic: 'Statistics and probability',
                        subtopic: [],
                      },
                      {
                        topic: 'Trigonometric Functions',
                        subtopic: [],
                      },
                      {
                        topic: 'Linear Inequalities',
                        subtopic: [],
                      },
                      {
                        topic: 'Permutations and Combinations',
                        subtopic: [],
                      },
                      {
                        topic: 'Conic Sections',
                        subtopic: [],
                      },
                      {
                        topic: 'Introduction to Three-dimensional Geometry',
                        subtopic: [],
                      },
                      {
                        topic: 'Derivatives',
                        subtopic: [],
                      },
                      {
                        topic: 'Probability',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Physics',
                    imageUrl: '/assets/img/festival/physics.png',
                    className: 'phy-box',
                    syllabus: [
                      {
                        topic: 'Physical World',
                        subtopic: [],
                      },
                      {
                        topic: 'Units of measurement',
                        subtopic: [],
                      },
                      {
                        topic: 'Motions in straight line',
                        subtopic: [],
                      },
                      {
                        topic: 'Motion in a plane',
                        subtopic: [],
                      },
                      {
                        topic: 'Laws of motion',
                        subtopic: [],
                      },
                      {
                        topic: 'Work, Energy, power',
                        subtopic: [],
                      },
                      {
                        topic: 'System of particles and rotational motion',
                        subtopic: [],
                      },
                      {
                        topic: 'Gravitation ',
                        subtopic: [],
                      },
                      {
                        topic: 'Mechanical Properties of Solids ',
                        subtopic: [],
                      },
                      {
                        topic: 'Mechanical Properties of Fluids',
                        subtopic: [],
                      },
                      {
                        topic: 'Thermal Properties of Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Thermodynamics',
                        subtopic: [],
                      },
                      {
                        topic: 'Kinetic Theory',
                        subtopic: [],
                      },
                      {
                        topic: 'Oscillations',
                        subtopic: [],
                      },
                      {
                        topic: 'Waves',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Chemistry',
                    imageUrl: '/assets/img/festival/chemistry.png',
                    className: 'che-box',
                    syllabus: [
                      {
                        topic: 'Some basic concepts of chemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'Structure of Atom ',
                        subtopic: [],
                      },
                      {
                        topic: 'Classification of elements and periodicity in properties',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical bonding and molecular structure ',
                        subtopic: [],
                      },
                      {
                        topic: 'Redox reactions ',
                        subtopic: [],
                      },
                      {
                        topic: 'Hydrogen ',
                        subtopic: [],
                      },
                      {
                        topic: 'Organic chemistry: Some basic principles and techniques. ',
                        subtopic: [],
                      },
                      {
                        topic: 'States of Matter: Gases and Liquids',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical Thermodynamics',
                        subtopic: [],
                      },
                      {
                        topic: 'Equilibrium',
                        subtopic: [],
                      },
                      {
                        topic: 's -Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Some p -Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Hydrocarbons',
                        subtopic: [],
                      },
                    ],
                  },
                ],
              },
              {
                grade: '12',
                subjects: [
                  {
                    subName: 'Maths',
                    imageUrl: '/assets/img/festival/math.png',
                    className: 'mat-box',
                    syllabus: [
                      {
                        topic: 'Relations and Functions',
                        subtopic: [],
                      },
                      {
                        topic: 'Inverse Trigonometric Functions',
                        subtopic: [],
                      },
                      {
                        topic: 'Matrices',
                        subtopic: [],
                      },
                      {
                        topic: 'Determinants',
                        subtopic: [],
                      },
                      {
                        topic: 'Continuity and Differentiability',
                        subtopic: [],
                      },
                      {
                        topic: 'Application of Derivatives',
                        subtopic: [],
                      },
                      {
                        topic: 'Integrals',
                        subtopic: [],
                      },
                      {
                        topic: 'Application of Integrals',
                        subtopic: [],
                      },
                      {
                        topic: 'Differential Equations',
                        subtopic: [],
                      },
                      {
                        topic: 'Vector Algebra',
                        subtopic: [],
                      },
                      {
                        topic: 'Three Dimensional Geometry',
                        subtopic: [],
                      },
                      {
                        topic: 'Linear Programming',
                        subtopic: [],
                      },
                      {
                        topic: 'Probability',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Physics',
                    imageUrl: '/assets/img/festival/physics.png',
                    className: 'phy-box',
                    syllabus: [
                      {
                        topic: 'Electric Charges & Fields',
                        subtopic: [],
                      },
                      {
                        topic: 'Electrostatic Potential & Capacitance',
                        subtopic: [],
                      },
                      {
                        topic: 'Current Electricity',
                        subtopic: [],
                      },
                      {
                        topic: 'Moving Charges and Magnetism',
                        subtopic: [],
                      },
                      {
                        topic: 'Magnetism and Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Electromagnetic Induction',
                        subtopic: [],
                      },
                      {
                        topic: 'Alternating Current',
                        subtopic: [],
                      },
                      {
                        topic: 'Electromagnetic Waves',
                        subtopic: [],
                      },
                      {
                        topic: 'Ray Optics and Optical Instruments',
                        subtopic: [],
                      },
                      {
                        topic: 'Wave Optics',
                        subtopic: [],
                      },
                      {
                        topic: 'Dual Nature of Radiation and Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Atoms',
                        subtopic: [],
                      },
                      {
                        topic: 'Nuclei',
                        subtopic: [],
                      },
                      {
                        topic: 'Semiconductor Electronics: Materials, Devices, and Simple Circuits',
                        subtopic: [],
                      },
                      {
                        topic: 'Communication Systems',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Chemistry',
                    imageUrl: '/assets/img/festival/chemistry.png',
                    className: 'che-box',
                    syllabus: [
                      {
                        topic: 'The Solid State',
                        subtopic: [],
                      },
                      {
                        topic: 'Solutions',
                        subtopic: [],
                      },
                      {
                        topic: 'Electrochemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical Kinetics',
                        subtopic: [],
                      },
                      {
                        topic: 'Surface Chemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'General Principles and Processes of Isolation of Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'The p-Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'The d-and f-Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Coordination Compounds',
                        subtopic: [],
                      },
                      {
                        topic: 'Haloalkanes and Haloarenes',
                        subtopic: [],
                      },
                      {
                        topic: 'Alcohols, Phenols and Ethers',
                        subtopic: [],
                      },
                      {
                        topic: 'Aldehydes, Ketones and Carboxylic Acids',
                        subtopic: [],
                      },
                      {
                        topic: 'Amines',
                        subtopic: [],
                      },
                      {
                        topic: 'Biomolecules',
                        subtopic: [],
                      },
                      {
                        topic: 'Polymers',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemistry in Everyday Life',
                        subtopic: [],
                      },
                    ],
                  },
                ],
              },
              {
                grade: '13',
                subjects: [
                  {
                    subName: 'Maths',
                    imageUrl: '/assets/img/festival/math.png',
                    className: 'mat-box',
                    syllabus: [
                      {
                        topic: 'Sets and functions',
                        subtopic: [],
                      },
                      {
                        topic: 'Algebra',
                        subtopic: [],
                      },
                      {
                        topic: 'Coordinate Geometry',
                        subtopic: [],
                      },
                      {
                        topic: 'Calculus',
                        subtopic: [],
                      },
                      {
                        topic: 'Statistics and probability',
                        subtopic: [],
                      },
                      {
                        topic: 'Trigonometric Functions',
                        subtopic: [],
                      },
                      {
                        topic: 'Linear Inequalities',
                        subtopic: [],
                      },
                      {
                        topic: 'Permutations and Combinations',
                        subtopic: [],
                      },
                      {
                        topic: 'Conic Sections',
                        subtopic: [],
                      },
                      {
                        topic: 'Introduction to Three-dimensional Geometry',
                        subtopic: [],
                      },
                      {
                        topic: 'Derivatives',
                        subtopic: [],
                      },
                      {
                        topic: 'Probability',
                        subtopic: [],
                      },
                      {
                        topic: 'Relations and Functions',
                        subtopic: [],
                      },
                      {
                        topic: 'Inverse Trigonometric Functions',
                        subtopic: [],
                      },
                      {
                        topic: 'Matrices',
                        subtopic: [],
                      },
                      {
                        topic: 'Determinants',
                        subtopic: [],
                      },
                      {
                        topic: 'Continuity and Differentiability',
                        subtopic: [],
                      },
                      {
                        topic: 'Application of Derivatives',
                        subtopic: [],
                      },
                      {
                        topic: 'Integrals',
                        subtopic: [],
                      },
                      {
                        topic: 'Application of Integrals',
                        subtopic: [],
                      },
                      {
                        topic: 'Differential Equations',
                        subtopic: [],
                      },
                      {
                        topic: 'Vector Algebra',
                        subtopic: [],
                      },
                      {
                        topic: 'Three Dimensional Geometry',
                        subtopic: [],
                      },
                      {
                        topic: 'Linear Programming',
                        subtopic: [],
                      },
                      {
                        topic: 'Probability',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Physics',
                    imageUrl: '//assets/img/festival/physics.png',
                    className: 'phy-box',
                    syllabus: [
                      {
                        topic: 'Physical World',
                        subtopic: [],
                      },
                      {
                        topic: 'Units of measurement',
                        subtopic: [],
                      },
                      {
                        topic: 'Motions in straight line',
                        subtopic: [],
                      },
                      {
                        topic: 'Motion in a plane',
                        subtopic: [],
                      },
                      {
                        topic: 'Laws of motion',
                        subtopic: [],
                      },
                      {
                        topic: 'Work, Energy, power',
                        subtopic: [],
                      },
                      {
                        topic: 'System of particles and rotational motion',
                        subtopic: [],
                      },
                      {
                        topic: 'Gravitation ',
                        subtopic: [],
                      },
                      {
                        topic: 'Mechanical Properties of Solids ',
                        subtopic: [],
                      },
                      {
                        topic: 'Mechanical Properties of Fluids',
                        subtopic: [],
                      },
                      {
                        topic: 'Thermal Properties of Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Thermodynamics',
                        subtopic: [],
                      },
                      {
                        topic: 'Kinetic Theory',
                        subtopic: [],
                      },
                      {
                        topic: 'Oscillations',
                        subtopic: [],
                      },
                      {
                        topic: 'Waves',
                        subtopic: [],
                      },
                      {
                        topic: 'Electric Charges & Fields',
                        subtopic: [],
                      },
                      {
                        topic: 'Electrostatic Potential & Capacitance',
                        subtopic: [],
                      },
                      {
                        topic: 'Current Electricity',
                        subtopic: [],
                      },
                      {
                        topic: 'Moving Charges and Magnetism',
                        subtopic: [],
                      },
                      {
                        topic: 'Magnetism and Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Electromagnetic Induction',
                        subtopic: [],
                      },
                      {
                        topic: 'Alternating Current',
                        subtopic: [],
                      },
                      {
                        topic: 'Electromagnetic Waves',
                        subtopic: [],
                      },
                      {
                        topic: 'Ray Optics and Optical Instruments',
                        subtopic: [],
                      },
                      {
                        topic: 'Wave Optics',
                        subtopic: [],
                      },
                      {
                        topic: 'Dual Nature of Radiation and Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Atoms',
                        subtopic: [],
                      },
                      {
                        topic: 'Nuclei',
                        subtopic: [],
                      },
                      {
                        topic: 'Semiconductor Electronics: Materials, Devices, and Simple Circuits',
                        subtopic: [],
                      },
                      {
                        topic: 'Communication Systems',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Chemistry',
                    imageUrl: '/assets/img/festival/chemistry.png',
                    className: 'che-box',
                    syllabus: [
                      {
                        topic: 'Some basic concepts of chemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'Structure of Atom ',
                        subtopic: [],
                      },
                      {
                        topic: 'Classification of elements and periodicity in properties',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical bonding and molecular structure ',
                        subtopic: [],
                      },
                      {
                        topic: 'Redox reactions ',
                        subtopic: [],
                      },
                      {
                        topic: 'Hydrogen ',
                        subtopic: [],
                      },
                      {
                        topic: 'Organic chemistry: Some basic principles and techniques. ',
                        subtopic: [],
                      },
                      {
                        topic: 'States of Matter: Gases and Liquids',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical Thermodynamics',
                        subtopic: [],
                      },
                      {
                        topic: 'Equilibrium',
                        subtopic: [],
                      },
                      {
                        topic: 's -Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Some p -Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Hydrocarbons',
                        subtopic: [],
                      },
                      {
                        topic: 'The Solid State',
                        subtopic: [],
                      },
                      {
                        topic: 'Solutions',
                        subtopic: [],
                      },
                      {
                        topic: 'Electrochemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical Kinetics',
                        subtopic: [],
                      },
                      {
                        topic: 'Surface Chemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'General Principles and Processes of Isolation of Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'The p-Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'The d-and f-Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Coordination Compounds',
                        subtopic: [],
                      },
                      {
                        topic: 'Haloalkanes and Haloarenes',
                        subtopic: [],
                      },
                      {
                        topic: 'Alcohols, Phenols and Ethers',
                        subtopic: [],
                      },
                      {
                        topic: 'Aldehydes, Ketones and Carboxylic Acids',
                        subtopic: [],
                      },
                      {
                        topic: 'Amines',
                        subtopic: [],
                      },
                      {
                        topic: 'Biomolecules',
                        subtopic: [],
                      },
                      {
                        topic: 'Polymers',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemistry in Everyday Life',
                        subtopic: [],
                      },
                    ],
                  },
                ],
              },
        ]
    },
    {
        exam: 'NEET',
        data : [
              {
                grade: '11',
                subjects: [
                  {
                    subName: 'Physics',
                    imageUrl: '/assets/img/festival/physics.png',
                    className: 'phy-box',
                    syllabus: [
                      {
                        topic: 'Physical World',
                        subtopic: [],
                      },
                      {
                        topic: 'Units of measurement',
                        subtopic: [],
                      },
                      {
                        topic: 'Motions in straight line',
                        subtopic: [],
                      },
                      {
                        topic: 'Motion in a plane',
                        subtopic: [],
                      },
                      {
                        topic: 'Laws of motion',
                        subtopic: [],
                      },
                      {
                        topic: 'Work, Energy, power',
                        subtopic: [],
                      },
                      {
                        topic: 'System of particles and rotational motion',
                        subtopic: [],
                      },
                      {
                        topic: 'Gravitation ',
                        subtopic: [],
                      },
                      {
                        topic: 'Mechanical Properties of Solids ',
                        subtopic: [],
                      },
                      {
                        topic: 'Mechanical Properties of Fluids',
                        subtopic: [],
                      },
                      {
                        topic: 'Thermal Properties of Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Thermodynamics',
                        subtopic: [],
                      },
                      {
                        topic: 'Kinetic Theory',
                        subtopic: [],
                      },
                      {
                        topic: 'Oscillations',
                        subtopic: [],
                      },
                      {
                        topic: 'Waves',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Chemistry',
                    imageUrl: '/assets/img/festival/chemistry.png',
                    className: 'che-box',
                    syllabus: [
                      {
                        topic: 'Some basic concepts of chemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'Structure of Atom ',
                        subtopic: [],
                      },
                      {
                        topic: 'Classification of elements and periodicity in properties',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical bonding and molecular structure ',
                        subtopic: [],
                      },
                      {
                        topic: 'Redox reactions ',
                        subtopic: [],
                      },
                      {
                        topic: 'Hydrogen ',
                        subtopic: [],
                      },
                      {
                        topic: 'Organic chemistry: Some basic principles and techniques. ',
                        subtopic: [],
                      },
                      {
                        topic: 'States of Matter: Gases and Liquids',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical Thermodynamics',
                        subtopic: [],
                      },
                      {
                        topic: 'Equilibrium',
                        subtopic: [],
                      },
                      {
                        topic: 's -Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Some p -Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Hydrocarbons',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Biology',
                    imageUrl: '/assets/img/festival/biology.png',
                    className: 'bio-box',
                    syllabus: [
                      {
                        topic: 'Cell Cycle and Cell Division',
                        subtopic: [],
                      },
                      {
                        topic: 'Photosynthesis in Higher Plants',
                        subtopic: [],
                      },
                      {
                        topic: 'Respiration in Plants',
                        subtopic: [],
                      },
                      {
                        topic: 'Plant - Growth and Development',
                        subtopic: [],
                      },
                      //Zoology
                      {
                        topic: 'Breathing and Exchange of Gases',
                        subtopic: [],
                      },
                      {
                        topic: 'Body Fluids and Circulation',
                        subtopic: [],
                      },
                      {
                        topic: 'Excretory Products and their Elimination',
                        subtopic: [],
                      },
                      {
                        topic: 'Locomotion and Movement',
                        subtopic: [],
                      },
                      {
                        topic: 'Neural Control and Coordination',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical Coordination and Integration',
                        subtopic: [],
                      },
                    ],
                  },
                ],
              },
              {
                grade: '12',
                subjects: [
                  {
                    subName: 'Physics',
                    imageUrl: '/assets/img/festival/physics.png',
                    className: 'phy-box',
                    syllabus: [
                      {
                        topic: 'Electric Charges & Fields',
                        subtopic: [],
                      },
                      {
                        topic: 'Electrostatic Potential & Capacitance',
                        subtopic: [],
                      },
                      {
                        topic: 'Current Electricity',
                        subtopic: [],
                      },
                      {
                        topic: 'Moving Charges and Magnetism',
                        subtopic: [],
                      },
                      {
                        topic: 'Magnetism and Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Electromagnetic Induction',
                        subtopic: [],
                      },
                      {
                        topic: 'Alternating Current',
                        subtopic: [],
                      },
                      {
                        topic: 'Electromagnetic Waves',
                        subtopic: [],
                      },
                      {
                        topic: 'Ray Optics and Optical Instruments',
                        subtopic: [],
                      },
                      {
                        topic: 'Wave Optics',
                        subtopic: [],
                      },
                      {
                        topic: 'Dual Nature of Radiation and Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Atoms',
                        subtopic: [],
                      },
                      {
                        topic: 'Nuclei',
                        subtopic: [],
                      },
                      {
                        topic: 'Semiconductor Electronics: Materials, Devices, and Simple Circuits',
                        subtopic: [],
                      },
                      {
                        topic: 'Communication Systems',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Chemistry',
                    imageUrl: '/assets/img/festival/chemistry.png',
                    className: 'che-box',
                    syllabus: [
                      {
                        topic: 'The Solid State',
                        subtopic: [],
                      },
                      {
                        topic: 'Solutions',
                        subtopic: [],
                      },
                      {
                        topic: 'Electrochemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical Kinetics',
                        subtopic: [],
                      },
                      {
                        topic: 'Surface Chemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'General Principles and Processes of Isolation of Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'The p-Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'The d-and f-Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Coordination Compounds',
                        subtopic: [],
                      },
                      {
                        topic: 'Haloalkanes and Haloarenes',
                        subtopic: [],
                      },
                      {
                        topic: 'Alcohols, Phenols and Ethers',
                        subtopic: [],
                      },
                      {
                        topic: 'Aldehydes, Ketones and Carboxylic Acids',
                        subtopic: [],
                      },
                      {
                        topic: 'Amines',
                        subtopic: [],
                      },
                      {
                        topic: 'Biomolecules',
                        subtopic: [],
                      },
                      {
                        topic: 'Polymers',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemistry in Everyday Life',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Biology',
                    imageUrl: '/assets/img/festival/biology.png',
                    className: 'bio-box',
                    syllabus: [
                      {
                        topic: 'Reproduction in Organisms',
                        subtopic: [],
                      },
                      {
                        topic: 'Sexual Reproduction in Flowering Plants',
                        subtopic: [],
                      },
                      {
                        topic: 'Strategies for Enhancement in Food Production',
                        subtopic: [],
                      },
                      {
                        topic: 'Biotechnology: Principles and Processes',
                        subtopic: [],
                      },
                      {
                        topic: 'Biotechnology and its Applications',
                        subtopic: [],
                      },
                      {
                        topic: 'Organisms and Populations',
                        subtopic: [],
                      },
                      {
                        topic: 'Ecosystem',
                        subtopic: [],
                      },
                      {
                        topic: 'Environmental Issues',
                        subtopic: [],
                      },
                      //Zoology
                      {
                        topic: 'Human Reproduction',
                        subtopic: [],
                      },
                      {
                        topic: 'Reproductive Health',
                        subtopic: [],
                      },
                      {
                        topic: 'Principles of Inheritance',
                        subtopic: [],
                      },
                      {
                        topic: 'Evolution',
                        subtopic: [],
                      },
                      {
                        topic: 'Human Health and Diseases',
                        subtopic: [],
                      },
                      {
                        topic: 'Microbes in Human Welfare',
                        subtopic: [],
                      },
                    ],
                  },
                ],
              },
              {
                grade: '13',
                subjects: [
                  {
                    subName: 'Physics',
                    imageUrl: '/assets/img/festival/physics.png',
                    className: 'phy-box',
                    syllabus: [
                      {
                        topic: 'Physical World',
                        subtopic: [],
                      },
                      {
                        topic: 'Units of measurement',
                        subtopic: [],
                      },
                      {
                        topic: 'Motions in straight line',
                        subtopic: [],
                      },
                      {
                        topic: 'Motion in a plane',
                        subtopic: [],
                      },
                      {
                        topic: 'Laws of motion',
                        subtopic: [],
                      },
                      {
                        topic: 'Work, Energy, power',
                        subtopic: [],
                      },
                      {
                        topic: 'System of particles and rotational motion',
                        subtopic: [],
                      },
                      {
                        topic: 'Gravitation ',
                        subtopic: [],
                      },
                      {
                        topic: 'Mechanical Properties of Solids ',
                        subtopic: [],
                      },
                      {
                        topic: 'Mechanical Properties of Fluids',
                        subtopic: [],
                      },
                      {
                        topic: 'Thermal Properties of Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Thermodynamics',
                        subtopic: [],
                      },
                      {
                        topic: 'Kinetic Theory',
                        subtopic: [],
                      },
                      {
                        topic: 'Oscillations',
                        subtopic: [],
                      },
                      {
                        topic: 'Waves',
                        subtopic: [],
                      },
                      {
                        topic: 'Electric Charges & Fields',
                        subtopic: [],
                      },
                      {
                        topic: 'Electrostatic Potential & Capacitance',
                        subtopic: [],
                      },
                      {
                        topic: 'Current Electricity',
                        subtopic: [],
                      },
                      {
                        topic: 'Moving Charges and Magnetism',
                        subtopic: [],
                      },
                      {
                        topic: 'Magnetism and Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Electromagnetic Induction',
                        subtopic: [],
                      },
                      {
                        topic: 'Alternating Current',
                        subtopic: [],
                      },
                      {
                        topic: 'Electromagnetic Waves',
                        subtopic: [],
                      },
                      {
                        topic: 'Ray Optics and Optical Instruments',
                        subtopic: [],
                      },
                      {
                        topic: 'Wave Optics',
                        subtopic: [],
                      },
                      {
                        topic: 'Dual Nature of Radiation and Matter',
                        subtopic: [],
                      },
                      {
                        topic: 'Atoms',
                        subtopic: [],
                      },
                      {
                        topic: 'Nuclei',
                        subtopic: [],
                      },
                      {
                        topic: 'Semiconductor Electronics: Materials, Devices, and Simple Circuits',
                        subtopic: [],
                      },
                      {
                        topic: 'Communication Systems',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Chemistry',
                    imageUrl: '/assets/img/festival/chemistry.png',
                    className: 'che-box',
                    syllabus: [
                      {
                        topic: 'Some basic concepts of chemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'Structure of Atom ',
                        subtopic: [],
                      },
                      {
                        topic: 'Classification of elements and periodicity in properties',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical bonding and molecular structure ',
                        subtopic: [],
                      },
                      {
                        topic: 'Redox reactions ',
                        subtopic: [],
                      },
                      {
                        topic: 'Hydrogen ',
                        subtopic: [],
                      },
                      {
                        topic: 'Organic chemistry: Some basic principles and techniques. ',
                        subtopic: [],
                      },
                      {
                        topic: 'States of Matter: Gases and Liquids',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical Thermodynamics',
                        subtopic: [],
                      },
                      {
                        topic: 'Equilibrium',
                        subtopic: [],
                      },
                      {
                        topic: 's -Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Some p -Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Hydrocarbons',
                        subtopic: [],
                      },
                      {
                        topic: 'The Solid State',
                        subtopic: [],
                      },
                      {
                        topic: 'Solutions',
                        subtopic: [],
                      },
                      {
                        topic: 'Electrochemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical Kinetics',
                        subtopic: [],
                      },
                      {
                        topic: 'Surface Chemistry',
                        subtopic: [],
                      },
                      {
                        topic: 'General Principles and Processes of Isolation of Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'The p-Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'The d-and f-Block Elements',
                        subtopic: [],
                      },
                      {
                        topic: 'Coordination Compounds',
                        subtopic: [],
                      },
                      {
                        topic: 'Haloalkanes and Haloarenes',
                        subtopic: [],
                      },
                      {
                        topic: 'Alcohols, Phenols and Ethers',
                        subtopic: [],
                      },
                      {
                        topic: 'Aldehydes, Ketones and Carboxylic Acids',
                        subtopic: [],
                      },
                      {
                        topic: 'Amines',
                        subtopic: [],
                      },
                      {
                        topic: 'Biomolecules',
                        subtopic: [],
                      },
                      {
                        topic: 'Polymers',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemistry in Everyday Life',
                        subtopic: [],
                      },
                    ],
                  },
                  {
                    subName: 'Biology',
                    imageUrl: '/assets/img/festival/biology.png',
                    className: 'bio-box',
                    syllabus: [
                      {
                        topic: 'Cell Cycle and Cell Division',
                        subtopic: [],
                      },
                      {
                        topic: 'Photosynthesis in Higher Plants',
                        subtopic: [],
                      },
                      {
                        topic: 'Respiration in Plants',
                        subtopic: [],
                      },
                      {
                        topic: 'Plant - Growth and Development',
                        subtopic: [],
                      },
                      //Zoology
                      {
                        topic: 'Breathing and Exchange of Gases',
                        subtopic: [],
                      },
                      {
                        topic: 'Body Fluids and Circulation',
                        subtopic: [],
                      },
                      {
                        topic: 'Excretory Products and their Elimination',
                        subtopic: [],
                      },
                      {
                        topic: 'Locomotion and Movement',
                        subtopic: [],
                      },
                      {
                        topic: 'Neural Control and Coordination',
                        subtopic: [],
                      },
                      {
                        topic: 'Chemical Coordination and Integration',
                        subtopic: [],
                      },
                      {
                        topic: 'Reproduction in Organisms',
                        subtopic: [],
                      },
                      {
                        topic: 'Sexual Reproduction in Flowering Plants',
                        subtopic: [],
                      },
                      {
                        topic: 'Strategies for Enhancement in Food Production',
                        subtopic: [],
                      },
                      {
                        topic: 'Biotechnology: Principles and Processes',
                        subtopic: [],
                      },
                      {
                        topic: 'Biotechnology and its Applications',
                        subtopic: [],
                      },
                      {
                        topic: 'Organisms and Populations',
                        subtopic: [],
                      },
                      {
                        topic: 'Ecosystem',
                        subtopic: [],
                      },
                      {
                        topic: 'Environmental Issues',
                        subtopic: [],
                      },
                      //Zoology
                      {
                        topic: 'Human Reproduction',
                        subtopic: [],
                      },
                      {
                        topic: 'Reproductive Health',
                        subtopic: [],
                      },
                      {
                        topic: 'Principles of Inheritance',
                        subtopic: [],
                      },
                      {
                        topic: 'Evolution',
                        subtopic: [],
                      },
                      {
                        topic: 'Human Health and Diseases',
                        subtopic: [],
                      },
                      {
                        topic: 'Microbes in Human Welfare',
                        subtopic: [],
                      },
                    ],
                  },
                ],
              },
        ]
    },
    
]